import moment from 'jalali-moment';

// Acceptable date predicate: reject invalid/sentinel dates like 0001-01-01T...
export const isAcceptableDateTime = (dt: string | number | Date): boolean => {
    const m = moment(dt);
    if (!m.isValid()) return false;
    const y = m.year();
    return y > 1; // filters out sentinel/min dates
};

// Returns formatted jYYYY/MM/DD or null if unacceptable
export const toJalaliDateOrNull = (dt: string | number | Date): string | null => {
    if (!isAcceptableDateTime(dt)) return null;
    return moment(dt).locale('fa').local().format('jYYYY/MM/DD');
};